import * as Actions from '../actions/sessions.actions';

const initialState = {
    capacity: {
        maxConcurrentUsers: 0,
        currentActiveUsers: 0,
        currentActiveParticipants: 0,
        totalActiveUsers: 0,
        capacityReached: false,
        licenseType: ''
    },
    loading: false,
    error: null
};

const sessionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_SESSION_CAPACITY: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.GET_SESSION_CAPACITY_SUCCESS: {
            return {
                ...state,
                capacity: action.payload,
                loading: false,
                error: null
            };
        }
        case Actions.GET_SESSION_CAPACITY_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default sessionsReducer;
